export default __webpack_public_path__ + "../staticImages/winefinder-sprite-Aroma_laktisch-2x.png";